import React, { Component } from 'react';
import QueryString from 'query-string';

import Paging from '../paging';
import Head from './Head';
import Title from '../main/Title';
import Sk from "../main/Sk";
import SearchKey from '../main/SearchKey';
import globalLib from '../../utils';
import * as ART from '../../const/article';
import Item from './Item';

class Customers extends Component {
    constructor(props) {
        super(props);
        let params = QueryString.parse(this.props.location.search);
        let page = params.page ? parseInt(params.page) : 1;

        this.state = {
            items: null,
            status: this.props.match.params.status,
            reload: false,
            counter: 0,
            page: page,
            keywords: this.props.match.params.keywords,
            search: false,
            total: 0
        }
    }

    render() {
        //let st = this.state.status?this.state.status.replace(/-/g,'_'):'';
        //let title = CUST.TITLE[st]?CUST.TITLE[st]:CUST.TITLE_DEFAULT;

        let title = ART.TITLE_DEFAULT;

        return (
            <main>
                <Title key="title-users" text={title} tool={
                    <SearchKey key="search-users"
                        onEnter = {this.onEnter}
                        onChange = {this.onChange}
                        refresh={this.Load}
                        reset={this.SearchReset}
                        defaultValue={this.state.keywords} />} />
                {
                    this.state.items ?
                        (
                            <div className="content">
                                <table>
                                    <Head />
                                    <tbody>
                                        {this.showItems()}
                                        
                                    </tbody>
                                </table>
                                <Paging key={`article-paging`}
                                    total={this.state.total}
                                    page={this.state.search ? 1 : this.state.page}
                                    page_size={20}
                                    uri={this.state.status ? `articles/${this.state.status}` : `articles`} />
                            </div>
                        )
                        :
                        <Sk />
                }

            </main>
        );
    }

    Load = () => {
        this.setState({ items: null, reload: false }, () => this.getArticles());
    }

    SearchReset = (e) => {
        this.props.match.params.keywords = null;
        this.setState({ keywords: ''}, () => this.startSearch());
    }

    startSearch = () => {
        this.setState({ search: true, items: null, reload: false }, () => this.getUsers());
    }

    onChange = (e) => {
        this.setState({ keywords:  e.target.value });
    }

    onEnter = (e) => {
        if (e.which === 13) {
            this.setState({ keywords:  e.target.value }, () => this.startSearch());
        }
    }

    onDelete = (id) => {
        console.log('Truoc', this.state.items);
        let items = this.state.items.filter((item) => {
            return item.id!==id;
        });
        this.setState({items}, () => {
            console.log('Sau', this.state.items);
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        
        // let items = nextProps.match.params.items;
        // if (items !== prevState.items) {
        //     return { items: items }
        // }
        
        let st = nextProps.match.params.status;
        if (st !== prevState.status) {
            return { status: st, reload: true, items: null }
        }

        let kw = nextProps.match.params.keywords;
        if (kw && kw !== prevState.keywords) {
            return { keywords: kw, reload: true, items: null }
        }

        let params = QueryString.parse(nextProps.location.search);
        let page = params.page ? parseInt(params.page) : 1;

        if (page !== prevState.page) {
            return { page, reload: true, items: null }
        }

        return null;
    }

    componentDidUpdate() {
        if (this.state.reload) {
            this.Load();
        }
    }

    componentDidMount() {
        this.getArticles();
    }

    showItems = () => {
        return this.state.items.map((item) => {
            item.img_url = this.state.img_url;
            return <Item key={item.id} data={item} callBack={this.onDelete} />
        });
    }

    getArticles = () => {
        let data = {
            page: this.state.search ? 1 : this.state.page,
            status: this.state.status,
            keywords: this.state.keywords
        };
        
        globalLib.restApi({ method: 'post', uri: 'articles', data })
            .then(result => {
                this.setState({ total: result.data.total, items: result.data.items, img_url: result.data.img_url, reload: false, counter: 0 });
                if (this.state.search) {
                    this.props.location.search = {};
                    this.setState({ search: false, page: 1 });
                    let uri = '/articles';
                    if (this.state.status) {
                        uri += '/' + this.state.status;
                    }
                    window.history.pushState({}, null, uri);
                }
            })
            .catch(err => {
                globalLib.checkResponseError(err);
                this.setState({ items: [], reload: false });
            });
    }
}

export default Customers;